import API from "../../api/api";
import React, { Component } from "react";
import "../../styles/css/Jobs/JobDetails.css";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";

const userId = localStorage.getItem("userId");
const userRole = localStorage.getItem("userRole");
var certifyId = 0;

class JobDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bidData: [],
      jobData: {},
      bidded: false,
      jobStatus: "",
      currentStatusId: "",

      jobId: "",
      inputDisabled: false,

      deed: false,
      fileMap: false,
      preSurveys: false,
      takingAndEasements: false,
      certifiersNameList: [],

      userBid: "",
      bidDuration: "",
      sNote: "",

      userBidEmpty: false,
      userBidCentsEmpty: false,
      bidDurationEmpty: false,
      sNoteEmpty: false,

      outBidRange: false,
      userBidMinus: false,
      userBidCentsMinus: false,
      bidDurationMinus: false,

      isSubmitted: false,
      isCreationLoading: false,
      userCreationSuccess: true,
      isDownloaded: true,
    };
  }

  componentDidMount() {
    this.setState(
      {
        bidData: this.props.bidData,
        jobData: this.props.jobData,
        bidded: this.props.cardData.bidded,

        jobStatus: this.props.jobData.job_status,
        deed: this.props.jobData.deed,
        fileMap: this.props.jobData.filemap,
        preSurveys: this.props.jobData.pre_survey,
        takingAndEasements: this.props.jobData.taking_easements,

        inputDisabled:
          this.props.jobData.job_status !== "Created" &&
          this.props.jobData.job_status !== "Posted"
            ? true
            : false,
      },
      () => this.preLoadBids()
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.jobData !== prevProps.jobData) {
      this.setState(
        {
          bidData: this.props.bidData,
          jobData: this.props.jobData,
          bidded: this.props.cardData.bidded,

          jobStatus: this.props.jobData.job_status,
          deed: this.props.jobData.deed,
          fileMap: this.props.jobData.filemap,
          preSurveys: this.props.jobData.pre_survey,
          takingAndEasements: this.props.jobData.taking_easements,

          inputDisabled:
            this.props.jobData.job_status !== "Created" &&
            this.props.jobData.job_status !== "Posted"
              ? true
              : false,
        },
        () => this.preLoadBids()
      );
    }
  }

  preLoadBids = () => {
    var bidAmount =
      this.state.bidData.length > 0 || this.state.bidData.length === undefined
        ? this.state.bidData.amount
        : "";
    this.setState(
      {
        userBid: bidAmount,
        bidDuration: this.state.bidData.duration,
        sNote: this.state.bidData.description,
      },
      () => this.setSertifiersNamesList()
    );
  };

  setSertifiersNamesList = () => {
    this.setState({
      certifiersNameList: this.state.jobData.certifier_name.split("\n"),
    });
  };

  inputHandleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(
      {
        [name]: value,
        [`${name}Empty`]: false,
      },
      () => this.checkMinus(name, value),
      this.checkBidRange(name, value)
    );
  };

  handleChangeStatus = (e) => {
    this.setState({ jobStatus: e.target.value }, () =>
      this.getIdByStatus(this.state.jobStatus)
    );
  };

  getIdByStatus = (status) => {
    const statuses = [
      { id: 4, status: "In-progress" },
      { id: 5, status: "Verify" },
    ];
    statuses.forEach((each) => {
      if (each.status === status) {
        this.setState({ currentStatusId: each.id }, () =>
          this.changeStatus(this.state.currentStatusId)
        );
      }
    });
  };

  changeStatus = (statusId) => {
    API.post("job/status/" + this.props.jobId + "/" + statusId)
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  checkMinus = (name, value) => {
    if (name === "userBid" && value !== null && value < 0) {
      this.setState({ userBidMinus: true });
    } else if (name === "userBid" && value !== null && value >= 0) {
      this.setState({ userBidMinus: false });
    }
    if (name === "bidDuration" && value !== null && value < 0) {
      this.setState({ bidDurationMinus: true });
    } else if (name === "bidDuration" && value !== null && value >= 0) {
      this.setState({ bidDurationMinus: false });
    }
    this.checkBidRange(name, value);
  };

  checkBidRange = (name, value) => {
    if (
      name === "userBid" &&
      (value < parseInt(this.state.jobData.min_bid, 10) ||
        value > parseInt(this.state.jobData.max_bid, 10)) &&
      value !== ""
    ) {
      this.setState({ outBidRange: true });
    } else if (
      name === "userBid" &&
      ((value >= parseInt(this.state.jobData.min_bid, 10) &&
        value <= parseInt(this.state.jobData.max_bid, 10)) ||
        value === "")
    ) {
      this.setState({ outBidRange: false });
    }
  };

  submitBid = (e) => {
    e.preventDefault();

    const jobData = {
      userBid: this.state.userBid,
      bidDuration: this.state.bidDuration,
      sNote: this.state.sNote,
    };

    Object.keys(jobData).forEach((key) => {
      if (jobData[key] === "" || jobData[key] === undefined) {
        this.setState({
          [`${key}Empty`]: true,
        });
      } else {
        this.setState({
          [`${key}Empty`]: false,
        });
      }
    });

    const sendData = {
      bid_amount: this.state.userBid,
      duration: this.state.bidDuration,
      description: this.state.sNote,
      user_id: userId,
      bid_status_id: 1,
      job_id: this.props.jobId,
    };

    if (
      !(this.state.userBid < 0) &&
      this.state.userBid !== "" &&
      !(this.state.bidDuration < 0) &&
      this.state.bidDuration !== "" &&
      this.state.bidDuration !== undefined &&
      this.state.userBid >= parseInt(this.state.jobData.min_bid, 10) &&
      this.state.userBid <= parseInt(this.state.jobData.max_bid, 10) &&
      this.state.sNote !== "" &&
      this.state.sNote !== undefined
    ) {
      this.setState({ isCreationLoading: true });

      const url = this.state.bidded
        ? "bid/create/" + this.state.bidData.id
        : "bid/create/0";

      API.post(url, sendData)
        .then((res) => {
          this.setState({
            isCreationLoading: false,
            isPostLoading: false,
          });
          this.showCreationMessage(true);
          this.clearAllFields();
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.setState({
            isCreationLoading: false,
            isPostLoading: false,
          });
          this.showCreationMessage(false);
        });
    }
  };

  clearAllFields = () => {
    this.setState({
      userBid: "",
      bidDuration: "",
      sNote: "",

      userBidEmpty: false,
      bidDurationEmpty: false,
      sNoteEmpty: false,

      userBidMinus: false,
      bidDurationMinus: false,
    });
  };

  showCreationMessage = (success) => {
    this.setState({
      isSubmitted: true,
      userCreationSuccess: success ? true : false,
    });
    setTimeout(() => {
      this.setState({
        isSubmitted: false,
        userCreationSuccess: true,
      });
      success && (window.location.href = "/");
    }, 1000);
  };
  downloadDocument(docId, docName) {
    console.log("hiew");
    API.get(`job/document/` + docId + `/download`, {
      responseType: "blob",
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = downloadUrl;
          link.download = docName;

          // const contentDisposition = res.headers["content-disposition"];

          // link.setAttribute("download", contentDisposition);
          document.body.appendChild(link);

          link.click();

          link.remove();
          this.setState({
            isDownloaded: true,
          });
        } else {
          this.setState({
            isDownloaded: false,
          });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        this.setState({
          isDownloaded: false,
        });
      });
  }
  render() {
    const {
      isCreationLoading,
      isSubmitted,
      userCreationSuccess,
      jobData,
    } = this.state;

    return (
      <div className="detailCardRoot">
        <div className="headerCardMain userCreationMain">
          <div>
            <form>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Job title</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">{jobData.name}</div>
                  </div>
                </div>
              </div>
              <div className="formMainRow halfRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Survey type</div>
                  <div className="halfInput">
                    <div className="jobViewData">
                      {jobData.survey_type_name}
                    </div>
                  </div>
                </div>
              </div>
              {userRole !== "Surveyor" && (
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv desktopDiv">
                    <div className="formInputLabelNewHalf">Bid range ($)</div>
                    <div
                      className="formInputDiv customInput"
                      style={{ width: "auto" }}
                    >
                      <div className="jobViewData">{jobData.min_bid}</div>
                    </div>
                    <span style={{ float: "left", paddingTop: "2px" }}>
                      &nbsp;-&nbsp;
                    </span>
                    <div className="formInputDiv customInput">
                      <div className="jobViewData">
                        {jobData.min_bid}&nbsp;USD
                      </div>
                    </div>
                  </div>
                  <div className="innerRowDiv mobileDiv">
                    <div className="formInputLabelNewHalfMax">
                      Bid range ($)
                    </div>
                    <div className="formInputDiv customInputMax">
                      <div className="jobViewData">{jobData.min_bid}</div>
                    </div>
                    <span style={{ float: "left", paddingTop: "2px" }}>
                      &nbsp;-&nbsp;
                    </span>
                    <div className="formInputDiv customInputMax">
                      <div className="jobViewData">
                        {jobData.max_bid}&nbsp;USD
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {jobData.survey_type_name === "Other" && (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="formInputLabelNew">Other Survey type</div>
                    <div className="formInputDiv">
                      <div className="jobViewData">
                        {jobData.other_survey_type}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="formMainRow">
                <div className="formInnerRow halfRow">
                  <div className="formInputLabelNew">Job completion date</div>
                  <div className="halfInput">
                    <div className="jobViewData">
                      {"due_date" in jobData && jobData.due_date.split(" ")[0]}
                    </div>
                  </div>
                </div>
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv">
                    <div className="formInputLabelNewHalf desktopDiv">
                      Bid duration
                    </div>
                    <div className="formInputLabelNewHalf mobileDiv">
                      Bid duration (Days)
                    </div>
                    <div className="formInputDiv halfInput2 fitWidth">
                      <div className="jobViewData">{jobData.duration}</div>
                    </div>
                    <span className="subLabel desktopDiv">Day(s)</span>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Tax map ID</div>
                  <div className="formInputDiv customInput2">
                    <div className="jobViewData">{jobData.tax_map_id}</div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Address</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">
                      {jobData.address}, {jobData.state}, {jobData.zip_code}
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Certified to</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">
                      {this.state.certifiersNameList.map((name) => {
                        certifyId++;
                        return <div key={certifyId}>{name}</div>;
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelCustom">
                    Research information available
                  </div>
                  <div className="fillingInputs">
                    <div className="checkInputs">
                      <input
                        type="checkbox"
                        id="deed"
                        name="deed"
                        checked={this.state.deed}
                        className="textInput checkboxInput"
                        disabled
                      />
                      <span className="checkLabel">Deed</span>
                    </div>
                    <div className="checkInputs">
                      <input
                        type="checkbox"
                        id="fileMap"
                        name="fileMap"
                        checked={this.state.fileMap}
                        className="textInput checkboxInput"
                        disabled
                      />
                      <span className="checkLabel">Filemap</span>
                    </div>
                    <div className="checkInputs2 extraMargin">
                      <input
                        type="checkbox"
                        id="preSurveys"
                        name="preSurveys"
                        checked={this.state.preSurveys}
                        className="textInput checkboxInput"
                        disabled
                      />
                      <span className="checkLabel">Prior surveys</span>
                    </div>
                    <div className="checkInputs2">
                      <input
                        type="checkbox"
                        id="takingAndEasements"
                        name="takingAndEasements"
                        checked={this.state.takingAndEasements}
                        className="textInput checkboxInput"
                        disabled
                      />
                      <span className="checkLabel">
                        Takings &amp; easements
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {jobData.documents ? (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="formInputLabelNew maxWidth minMargin">
                      Documents
                    </div>
                    <br />
                    <div className="maxWidth">
                      <div className="jobViewData justified">
                        <div className="docContainer">
                          {jobData.documents.map((doc, i) => {
                            return (
                              <div className="docItem" key={i}>
                                <h3>{doc.file_name}</h3>
                                {/* <a
                                  download={doc.file_name}
                                  href={`${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/job/document/${doc.id}/download`}
                                >
                                  <GetAppIcon style={{ color: "#FFFFFF" }} />
                                </a> */}

                                <GetAppIcon
                                  onClick={() =>
                                    this.downloadDocument(doc.id, doc.file_name)
                                  }
                                  style={{
                                    color: "#FFFFFF",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.isDownloaded ? "none" : "block",
                      }}
                    >
                      <span>Something went wrong. Try again.</span>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew maxWidth minMargin">
                    Description
                  </div>
                  <div className="maxWidth">
                    <div className="jobViewData justified">
                      {jobData.description}
                    </div>
                  </div>
                </div>
              </div>
              {(userRole === "Surveyor" || userRole === "Surveyor User") && (
                <div>
                  <div className="formMainRow">
                    <div className="formInnerRow halfRow">
                      <div className="desktopDiv">
                        <div className="formInputLabelNewHalf">
                          Bid range ($)
                        </div>
                        <div className="formInputDiv customInput fitWidth">
                          <div className="jobViewData">{jobData.min_bid}</div>
                        </div>
                        <span style={{ float: "left", paddingTop: "5px" }}>
                          &nbsp;-&nbsp;
                        </span>
                        <div className="formInputDiv customInput fitWidth">
                          <div className="jobViewData">
                            {jobData.max_bid}&nbsp;USD
                          </div>
                        </div>
                      </div>
                      <div className="innerRowDiv mobileDiv">
                        <div className="formInputLabelNewHalfMax">
                          Bid range ($)
                        </div>
                        <div className="formInputDiv customInputMax fitWidth">
                          <div className="jobViewData">{jobData.min_bid}</div>
                        </div>
                        <span style={{ float: "left", paddingTop: "18px" }}>
                          &nbsp;-&nbsp;
                        </span>
                        <div className="formInputDiv customInputMax fitWidth">
                          <div className="jobViewData">
                            {jobData.max_bid} &nbsp;USD
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="formInnerRow halfRow">
                      <div className="messageBody messageDivSub userCreationSuccessColor regNotification">
                        <div className="messageAction messageActionReg">
                          <ErrorOutileIcon />
                        </div>
                        <div className="userCreationSuccess">
                          Your bid value should not exceed or fall less than the
                          amount set by the Title Company
                        </div>
                      </div>
                    </div>
                    <hr className="formDivider" />
                  </div>
                  <div className="formMainRow">
                    <div className="formInnerRow halfRow">
                      <div className="bidInputs" style={{ overflow: "hidden" }}>
                        <div className="bidValue">Your bid ($)*</div>
                        <div className="">
                          <div className="formInputDiv customInput userBidWidth bidRangeDiv">
                            <input
                              type="number"
                              id="userBid"
                              name="userBid"
                              value={this.state.userBid}
                              className="textInput bidRangeDiv"
                              onChange={this.inputHandleChange}
                              maxLength="7"
                              disabled={this.state.inputDisabled}
                            />
                          </div>
                          <span className="bidUnit">USD</span>
                        </div>
                      </div>
                      <div
                        className="ErrorLog bidRangeErr"
                        style={{
                          display: this.state.userBidEmpty ? "block" : "none",
                        }}
                      >
                        <span>Bid is required</span>
                      </div>
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.userBidMinus ? "block" : "none",
                        }}
                      >
                        <span>Minus values are not allowed</span>
                      </div>
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.outBidRange ? "block" : "none",
                        }}
                      >
                        <span>Bid must be within the bid range</span>
                      </div>
                    </div>
                    <div className="formInnerRow halfRow">
                      <div className="innerRowDiv removeMarginLeft">
                        <div className="bidEstimation desktopDiv">
                          Estimated completion*
                        </div>
                        <div className="bidEstimation mobileDiv">
                          Estimated completion (Days)*
                        </div>
                        <div className="formInputDiv halfInput2 bidEstimationInput">
                          <input
                            type="number"
                            id="bidDuration"
                            name="bidDuration"
                            value={this.state.bidDuration}
                            className="textInput bidRangeDiv"
                            onChange={this.inputHandleChange}
                            disabled={this.state.inputDisabled}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.bidDurationEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Estimated completion is required</span>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.bidDurationMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                        <span className="subLabel desktopDiv">Day(s)</span>
                      </div>
                    </div>
                  </div>
                  <div className="formMainRow">
                    <div className="formInnerRow">
                      <div className="formInputLabelNew maxWidth minMargin">
                        Surveyor note*
                      </div>
                      <div className="maxWidth">
                        <textarea
                          id="sNote"
                          name="sNote"
                          className="textInput maxHeight"
                          value={this.state.sNote}
                          onChange={this.inputHandleChange}
                          disabled={this.state.inputDisabled}
                          maxLength="190"
                        ></textarea>
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.sNoteEmpty ? "block" : "none",
                          }}
                        >
                          <span>Surveyor note is required</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="submitButtons">
                <div className="userCreationMessageDiv">
                  <div
                    className="userCreationMessage messageResponsive"
                    id="userCreationMessage"
                  >
                    {isSubmitted ? (
                      userCreationSuccess ? (
                        <div className="messageBody userCreationSuccessColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationSuccess">
                            Bid completed!
                          </div>
                        </div>
                      ) : (
                        <div className="messageBody userCreationFailColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationFail">Error</div>
                        </div>
                      )
                    ) : null}
                  </div>
                  {userRole === "Surveyor" || userRole === "Surveyor User" ? (
                    jobData.job_status === "In-progress" ||
                    jobData.job_status === "Verify" ? (
                      <div className="createButtonsDiv submitBidBtn">
                        <select
                          id="changeJobStatus"
                          name="changeJobStatus"
                          className="changeJobStatus"
                          value={this.state.jobStatus}
                          onChange={this.handleChangeStatus}
                        >
                          <option value="In-progress">In-progress</option>
                          <option value="Verify">Verify</option>
                        </select>
                      </div>
                    ) : jobData.job_status === "Completed" ? (
                      <div className="createButtonsDiv submitBidBtn">
                        <button
                          type="submit"
                          className="formSubmit jobCreateButton"
                          disabled
                        >
                          <div>
                            <span>Completed</span>
                          </div>
                        </button>
                      </div>
                    ) : (
                      <div className="createButtonsDiv submitBidBtn">
                        <button
                          type="submit"
                          className="formSubmit jobCreateButton"
                          onClick={this.submitBid}
                        >
                          {isCreationLoading ? (
                            <CircularProgress className="circularColor2" />
                          ) : (
                            <div>
                              {this.state.bidded ? (
                                <span>Update bid</span>
                              ) : (
                                <span>Bid</span>
                              )}
                            </div>
                          )}
                        </button>
                      </div>
                    )
                  ) : userRole === "Admin" ? (
                    <div></div>
                  ) : (
                    <div className="createButtonsDiv submitBidBtn">
                      <button
                        type="submit"
                        className="formSubmit jobCreateButton"
                        onClick={this.submitBid}
                      >
                        {isCreationLoading ? (
                          <CircularProgress className="circularColor2" />
                        ) : (
                          <div>
                            <span>Post</span>
                          </div>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default JobDetails;



// WEBPACK FOOTER //
// ./src/pages/Jobs/JobDetails.js